export const MailCheckConstants = {
  labels: {
    ROLLOVER: 'ROLLOVER',
  },
  mailACheckPage: {
    headerTitle: 'Mail your check',
    pageDesc:
      'T. Rowe Price can invest your assets once we have received your check.',
    stepTitle1: 'Print your investment slip',
    stepTitle2: 'Mail your check and investment slip to:',
    noteTitle: `What's next?`,
    noteDesc:
      'We will add funds to your account once we have received your check in the mail.',
  },
};
